import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M10.9999 5C10.9999 4.44771 11.4476 4 11.9999 4C12.5522 4 12.9999 4.44771 12.9999 5L12.9999 19C12.9999 19.5523 12.5522 20 11.9999 20C11.4476 20 10.9999 19.5523 10.9999 19V5Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M4.29289 12.707C3.90237 12.3165 3.90237 11.6835 4.29289 11.293L11.2929 4.29297C11.6834 3.90244 12.3164 3.90244 12.707 4.29297L19.707 11.293C20.0975 11.6835 20.0975 12.3165 19.707 12.707C19.3164 13.0976 18.6834 13.0976 18.2929 12.707L11.9999 6.41406L5.70696 12.707C5.31643 13.0976 4.68342 13.0976 4.29289 12.707Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }